'use strict';

module.exports = /*@ngInject*/ function () {
    return {
        restrict: 'EA',
        require: '^ngModel',
        transclude: true,
        scope: {
            ngModel: '=',
            config: '='
        },
        template: [
            `<div class="btn-group" ng-transclude></div>
            <div class="btn-group" ng-repeat="tab in structure" ng-show="tab.visible">
                <div type="button" class="btn btn-outline-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                    {{('I18N_TRIP.MESSAGESELECTORS_' + tab.displayName).toUpperCase() | translate}}
                </div>
                <div class="dropdown-menu">
                    <a class="dropdown-item"  role="button" ng-repeat="message in tab.sub" ng-class="{\'separator\' : message.split}" ng-show="message.visible"
                    ng-click="handleClick(message.messageName)"
                    ng-if="!message.split">{{'I18N_TRIP.MESSAGES_' + message.messageName | translate}} </a>
                </div>

            </div>
            `
        ].join(""),
        controller: ["$scope", "ConfigurationStoreService", "ProjectService","$rootScope", function($scope, ConfigurationStoreService, ProjectService, $rootScope) {

            generateMenu();

            $rootScope.$on('project-config-updated', generateMenu);
            
            function generateMenu() {
                var projectConfiguration = ConfigurationStoreService.getProjectConfiguration( ProjectService.getSelectedProjectId());
                $scope.structure = projectConfiguration && projectConfiguration.graphAnalysis && projectConfiguration.graphAnalysis.activeMessageSelectors || [];
            }
            $scope.handleClick = function (messageName) {
            "use strict";
            $scope.ngModel(messageName);
         };
    
                    
         }],
    };
};
